import { combineReducers } from 'redux';

import filtersReducer from './filtersReducer';
import feedReducer from './feedReducer';
import mapReducer from './mapReducer';

export default combineReducers({
  feed: feedReducer,
  filters: filtersReducer,
  map: mapReducer,
});
